export default __webpack_public_path__ + "static/mystery-bottle-full-83417061cf598712ce8d238cb984160f.png";